<nz-modal nzCentered [nzMaskClosable]="false" class="custom-modal" [(nzVisible)]="isVisible"
    [nzTitle]="editAssignmentDetail ? 'Edit Assignment' : 'Add New Assignment'" [nzWidth]="1000"
    [nzOkDisabled]="lst_AddedStock?.length == 0 || isQuantityExists || invoiceNotExist || !isStockSelected || !isValidStockSelected"
    nzOkText="Save" nzCancelText="Cancel" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent class="custom-modal">
        <div class="modal-height">
            <nz-radio-group [(ngModel)]="radioValue" (ngModelChange)="changeassignmentInvoiceType()" *ngIf="!editAssignmentDetail && !assignemntForInvoice">
                <label nz-radio nzValue="1">
                    <nz-form-label nzFor="invoice" class="modal-label label-width-icon">Select an Invoice
                    <i class="text-primary pointer" nz-icon [nzType]="'sync'" [nzSpin]="isSyncCustomer"
                        (click)="getLatestCreatedInvoices()"></i>
                </nz-form-label>
            </label>
                <label nz-radio nzValue="2">
                     <nz-form-label nzFor="invoice" class="modal-label label-width-icon">
                        Check for Assignments (1 mo.)
                    </nz-form-label>
                </label>
              </nz-radio-group>
            <form nz-form [formGroup]="_fS.addUpdateAssignmentForm" class="modal">
                <input nz-input style="display: none" />
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                        *ngIf="!editAssignmentDetail && !assignemntForInvoice">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Please select customer">
                                <div class="last5Invoices">
                                    <nz-skeleton *ngIf="isDataLoaded" [nzActive]="true" [nzParagraph]="{ rows: 4}">
                                    </nz-skeleton>
                                    <nz-list nzSize="small" *ngIf="!isDataLoaded">
                                        <nz-list-item *ngFor="let item of latestInvoices"
                                            [ngClass]="item.invoiceNo == _fS.addUpdateAssignmentForm.get('invoiceId')?.value && !item.isAssigned ? 'higlightItem': ''"
                                            [ngClass]="item.isAssigned ? 'disable': 'cursor'">
                                            <div (click)="fillInvoiceDataInTextBox(item)"
                                                [ngClass]="item.invoiceNo == _fS.addUpdateAssignmentForm.get('invoiceId')?.value && !item.isAssigned ? 'higlightItem': ''">
                                                Invoice {{item.invoiceNo}} | {{item.customerName}} | {{item.txnDate |
                                                date : 'MM/dd/yyyy'}}
                                                | ${{item.totalAmount | number : '1.2-2'}}</div>
                                        </nz-list-item>
                                    </nz-list>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Please select quickbooks invoice">
                                <nz-form-label nzRequired nzFor="customer" class="modal-label label-width-icon">
                                    QuickBooks Invoice#
                                    <!-- <i class="text-primary pointer" nz-icon [nzType]="'sync'" [nzSpin]="isSyncInvoice"
                                        (click)="syncLatestInvoices()"></i> -->
                                </nz-form-label>
                                <!-- <nz-select *ngIf="!editAssignmentDetail" id="customer" formControlName="invoiceId"
                                    class="select" nzShowSearch [nzDisabled]="editAssignmentDetail ? true : false"
                                    nzPlaceHolder="Select QuickBooks Invoice">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Invoice">
                                    </nz-option>
                                </nz-select> -->
                                <!-- *ngIf="editAssignmentDetail"  -->
                                <input class="input" nz-input formControlName="invoiceId"
                                    [ngClass]="invoiceNotExist ? 'redBorder': ''" (blur)="fetchCustomer()"/>
                                <!-- <p *ngIf="invoiceNotExist" class="invalidInvoice">This invoice number does not exist</p> -->
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">

                        <nz-form-item>
                            <nz-form-control nzErrorTip="Please select customer">
                                <nz-form-label nzRequired nzFor="customer" class="modal-label label-width-icon">
                                    Customer
                                    <!-- <i class="text-primary pointer" nz-icon [nzType]="'sync'" [nzSpin]="isSyncCustomer"
                                    (click)="syncLatestCustomers()"></i> -->
                                </nz-form-label>
                                <!-- <nz-select *ngIf="!editAssignmentDetail" id="customer" formControlName="customerId"
                                    class="select" nzShowSearch [nzDisabled]="editAssignmentDetail ? true : false"
                                    nzPlaceHolder="Select Customer" (ngModelChange)="onSelectCustomer($event)">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Customer">
                                    </nz-option>
                                </nz-select> -->
                                <!-- *ngIf="editAssignmentDetail"  -->
                                <input class="input disable" nz-input formControlName="customerId" readonly />
                            </nz-form-control>
                        </nz-form-item>
                        <!-- <nz-form-item>
                            <nz-form-control nzErrorTip="Please select quickbooks invoice">
                                <nz-form-label nzRequired nzFor="customer" class="modal-label label-width-icon">
                                    QuickBooks Invoice#
                                    <i class="text-primary pointer" nz-icon [nzType]="'sync'" [nzSpin]="isSyncInvoice"
                                        (click)="syncLatestInvoices()"></i>
                                </nz-form-label>
                                <nz-select *ngIf="!editAssignmentDetail" id="customer" formControlName="invoiceId"
                                    class="select" nzShowSearch [nzDisabled]="editAssignmentDetail ? true : false"
                                    nzPlaceHolder="Select QuickBooks Invoice">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Invoice">
                                    </nz-option>
                                </nz-select>
                                <input *ngIf="editAssignmentDetail" class="input" nz-input
                                    formControlName="invoiceId" />
                            </nz-form-control>
                        </nz-form-item> -->
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control>
                                <nz-form-label nzFor="notes" class="modal-label">Notes</nz-form-label>
                                <input id="notes" name="notes" class="input" formControlName="notes" nz-input rows="2"
                                    maxlength="200" placeholder="Enter Notes">
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control>
                                <nz-form-label nzFor="notes" class="modal-label">PO</nz-form-label>
                                <input class="input disable" nz-input formControlName="purchaseOrder" readonly />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row top_margin" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                        <nz-form-control>
                            <button class="add-new-number-btn" nz-button nzType="default" nz-popover
                                [nzPopoverTitle]=" titleTemplate" nzPopoverTrigger="click"
                                [(nzPopoverVisible)]="isStockPopOver" [nzPopoverOverlayClassName]="'stock-popover'"
                                (nzPopoverVisibleChange)="hideShowAddStock($event)"
                                [nzPopoverContent]="addStockTemplate" nzPopoverPlacement="rightTop"><i nz-icon
                                    nzType="plus-circle" nzTheme="outline"></i>
                                Add Stock </button>
                        </nz-form-control>
                    </div>
                </div>
            </form>
            <br>
            <nz-table nzTableLayout="fixed" #basicTable [nzData]="lst_AddedStock" [nzShowPagination]="false"
                [nzScroll]="{ y: 'calc(100vh - 40em)' }" [nzPageSize]="lst_AddedStock.length" class="mb-1"
                *ngIf="lst_AddedStock.length > 0">
                <thead>
                    <tr class="tableheader">
                        <th nzWidth="50px">#</th>
                        <th nzWidth="200px" [nzAlign]="'left'">Stock</th>
                        <th [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sortPart(!isAscPart)">Part Number
                        </th>
                        <th [nzAlign]="'right'">Quantity</th>
                        <th nzWidth="100px" [nzAlign]="'right'">Action</th>
                    </tr>
                </thead>
                <!-- <tbody>
                    <tr *ngFor="let p of basicTable.data; let pi = index;">
                        <td>{{pi+1 }}</td>
                        <td [nzAlign]="'left'">{{ p.name }}</td>
                        <td [nzAlign]="'left'" [nzTooltipTitle]="p.note ? p.note : ''" [nzTooltipPlacement]="['top']" nz-tooltip>
                            <ng-container *ngFor="let i of p.partNumbers;let n = index;"> {{ i.partNumber }} ({{i.assignedQuantity}})
                                <span *ngIf="n != p.partNumbers.length - 1"> | </span>
                            </ng-container>
                        </td>
                        <td [nzAlign]="'right'">
                            <img class="mr-1 close-icon" src="./assets/images/Close.svg" (click)="removePartNumber(p,pi)">
                        </td>
                    </tr>
                </tbody> -->
                <tbody *ngIf="editAssignmentDetail">
                    <ng-container *ngFor="let p of basicTable.data;let n = index;">
                        <tr>
                            <td nzWidth="50px"></td>
                            <td [nzAlign]="'left'" nzEllipsis>
                                <!-- {{ p.stockName }} -->
                                <nz-select [(ngModel)]="p.stockId" nzShowSearch nzPlaceHolder="Select Stock"
                                    (ngModelChange)="onSelectStock($event,p,n)" [nzAllowClear]="false" class="w-150"
                                    [ngClass]="invalidstocks.includes(p.partNumber) && !isNumberField ? 'redBorder' : ''" (nzFocus)="getStockListWithQty(p.partNumber)">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Stock_Qty" nzCustomContent>
                                        <div style="display:flex;justify-content: space-between;">
                                            <div>{{c.text}}</div>
                                            <div *ngIf="c.text != 'N2O'">{{
                                                c.availableQuantity }}</div>
                                            </div>
                                    </nz-option>
                                    <nz-option *ngIf="isLoadingList" nzDisabled nzCustomContent>
                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                        Loading Data...
                                    </nz-option>
                                </nz-select>
                            </td>
                            <td [nzAlign]="'left'" nzEllipsis>{{ p.partNumber }}</td>
                            <td [nzAlign]="'right'">
                                <nz-input-number
                                    [ngClass]="invalidstocks.includes(p.partNumber) && isNumberField ? 'redBorder' : ''"
                                    [(ngModel)]="p.assignedQuantity" class="w-30" [nzMin]="1" [nzStep]="1"
                                    (nzBlur)="checkIfValidStockSelected(p.stockId,p)"></nz-input-number>
                            </td>
                            <td [nzAlign]="'right'">
                                <img class="mr-1 close-icon" src="./assets/images/Close.svg"
                                    (click)="removePartNumber(p,n)">
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tbody *ngIf="!editAssignmentDetail">
                    <ng-container *ngFor="let p of lst_AddedStock">
                        <tr *ngFor="let part of p.partNumbers;let n = index;">
                            <td nzWidth="50px"></td>
                            <td [nzAlign]="'left'" nzEllipsis>
                                <!-- {{p.name }} -->
                                <nz-select [(ngModel)]="p.id" nzShowSearch nzPlaceHolder="Select Stock"
                                    (ngModelChange)="onSelectStock($event, part,n)" [nzAllowClear]="false" class="w-150"
                                    [ngClass]="invalidstocks.includes(part.partNumber) && !isNumberField ? 'redBorder' : ''"  (nzFocus)="getStockListWithQty(part.partNumber)">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Stock_Qty" nzCustomContent>
                                        <div style="display:flex;justify-content: space-between;">
                                            <div>{{c.text}}</div>
                                            <div *ngIf="c.text != 'N2O'">{{
                                                c.availableQuantity }}</div>
                                            </div>
                                    </nz-option>
                                    <nz-option *ngIf="isLoadingList" nzDisabled nzCustomContent>
                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                        Loading Data...
                                    </nz-option>
                                </nz-select>
                            </td>
                            <td [nzAlign]="'left'" nzEllipsis>{{ part.partNumber }}</td>
                            <td [nzAlign]="'right'">
                                <nz-input-number
                                    [ngClass]="invalidstocks.includes(part.partNumber) && isNumberField ? 'redBorder' : ''"
                                    class="w-30" [(ngModel)]="part.assignedQuantity"
                                    (ngModelChange)="checkIfValidStockSelected(p.id,part)" [nzMin]="1" [nzStep]="1">
                                </nz-input-number>
                            </td>
                            <td [nzAlign]="'right'">
                                <img class="mr-1 close-icon" src="./assets/images/Close.svg"
                                    (click)="removePartNumber(p,n,part)">
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </nz-table>
            <ng-template #titleTemplate>
                Add Stock <img class="float-right close-icon" src="./assets/images/Close.svg"
                    (click)="hideShowAddStock(false)">
                <!-- <i class="float-right pointer" nz-icon nzType="close" (click)="hideShowAddStock(false)"></i> -->
            </ng-template>
            <ng-template #addStockTemplate>
                <form nz-form [formGroup]="_fS.addAssignmentStockForm" class="modal">
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Please select stock" nzRequired
                            class="input-field input-box required-input-icon">
                            <nz-select formControlName="stockName" nzShowSearch nzPlaceHolder="Select Stock"
                                (ngModelChange)="onSelectStock($event)">
                                <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Stock"></nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Please select part number" nzRequired
                            class="input-field input-box required-input-icon">
                            <nz-select formControlName="partNumber" nzShowSearch nzPlaceHolder="Select Part Number"
                                (ngModelChange)="onSelectPartNumber($event)">
                                <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Parts"></nz-option>
                            </nz-select>
                            <span class="text-danger"
                                *ngIf="isPartNumberExist && !_fS.addAssignmentStockForm.controls['partNumber'].hasError('required')">
                                Selected part number is already added for the selected stock
                            </span>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Part quantity is required" nzRequired
                            class="input-field input-box required-input-icon">
                            <input class="input" type="number" nz-input placeholder="Enter Part Quantity"
                                formControlName="partQuantity" min="1" step="1" (keypress)="_cS.validateNumber($event)"
                                (keyup)="checkQuantity()"
                                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="text-right mb-0">
                        <nz-form-control>
                            <button nz-button nzType="default" class="modal-footer-btn right_margin cancel-btn"
                                (click)="hideShowAddStock(false)">Cancel</button>
                            <button class="btn-blue modal-footer-btn" nz-button nzType="primary"
                                [disabled]="isQuantityExists" (click)="addStockToAssignment()">Save</button>
                        </nz-form-control>
                    </nz-form-item>
                </form>
            </ng-template>
        </div>
    </ng-container>
</nz-modal>